<template>
  <div class="schedule_zone" v-if="header.length">
    <div class="zone_tab">
      <div class="zone_tab_item" v-for="(item, ind) in header" :key="ind"  @click="changeSchedule(item)" :class="{ active: schedule_name === item.schedule_name }">
        <p>{{ item.schedule_name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    get_leader_board_cycle
  } from '@/api/official'

  export default {
    props: {
      param: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        zone: '',
        show_zone_select: false,
        zone_type: {
          'Pacific/Honolulu': '(UTC-10:00) Hawaii',
          'America/Anchorage': '(UTC-09:00) Alaska',
          'America/Los_Angeles': '(UTC-08:00) Los Angeles (Pacific Time)',
          'America/Denver': '(UTC-07:00) Denver (Mountain Time)',
          'America/Chicago': '(UTC-06:00) Chicago (Central Time)',
          'America/Mexico_City': '(UTC-06:00) Mexico City',
          'America/Bogota': '(UTC-05:00) Bogota, Lima, Quito',
          'America/New_York': '(UTC-05:00) New York (Eastern Time)',
          'America/Santiago': '(UTC-04:00) Asuncion,Santiago',
          'Atlantic/Bermuda': '(UTC-04:00) Bermuda (Atlantic Time)',
          'America/Sao_Paulo': '(UTC-03:00) São Paulo',
          'America/Argentina/Buenos_Aires': '(UTC-03:00) Buenos Aires',
          'Europe/London': '(UTC+00:00) London',
          'Europe/Paris': '(UTC+01:00) Rome, Madrid, Paris',
          'Africa/Cairo': '(UTC+02:00) Cairo',
          'Asia/Jerusalem': '(UTC+02:00) Tel Aviv',
          'Europe/Moscow': '(UTC+03:00) Moscow, Istanbul',
          'Asia/Colombo': '(UTC+05:30) Mumbai, New Delhi',
          'Asia/Jakarta': '(UTC+07:00) Bangkok, Hanoi, Jakarta',
          'Asia/Kuala_Lumpur': '(UTC+08:00) Kuala Lumpur, Singapore',
          'Asia/Tokyo': '(UTC+09:00) Seoul, Tokyo',
          'Australia/Brisbane': '(UTC+10:00) Brisbane',
          'Australia/Sydney': '(UTC+10:00) Melbourne, Sydney',
          'Pacific/Auckland': '(UTC+12:00) Auckland, Wellington'
        },
        header: [],
        schedule_name: ''
      }
    },
    methods: {
      initCycle() {
        get_leader_board_cycle({
          group_type: 'brazil'
        })
          .then(res => {
            this.header = res.data.list.map((item, index) => {
              if(index === 0) {
                this.zone = item.time_zone || 'America/New_York'
                this.schedule_name = item.schedule_name
              }
              return item
            })
          })
          .catch(err => {
            console.log(err)
          })
      },
      changeSchedule(item) {
        this.schedule_name = item.schedule_name
        this.zone = item.time_zone || 'America/New_York'
        this.$parent.changeSchedule(item)
      },
      changeZone(zone) {
        this.zone = zone
        this.show_zone_select = false
        this.$parent.changeZone(zone)
      }
    },
    created() {
      this.initCycle()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
        .schedule_zone {
          margin-bottom: 20px;
          position: relative;
          z-index: 10;
          .zone_tab {
            width: 560px;
            height: 40px;
            // background: url('/ppst/static/img/ppst/shcedule/pt/tab_line.png') center center;
            // background-repeat: no-repeat;
            position: relative;
            .zone_tab_item {
              display: inline-block;
              width: 112px;
              height: 40px;
              position: relative;
              cursor: pointer;
              background: url('/ppst/static/img/ppst/shcedule/en/tab_single_line.png') center center;
              background-repeat: no-repeat;
              p {
                padding: 0px 8px;
                margin: 0px;
                text-align: center;
                color: #00ffa8;
                font-size: 16px;
                text-align: center;
                line-height: 40px;
              }
            }
            .zone_tab_item.active {
              background: url('/ppst/static/img/ppst/shcedule/en/tab_select.png') center center;
              background-repeat: no-repeat;
              p {
                color: #0f7d43;
              }
            }
          }
        }
</style>
